import React, { useState, useEffect } from 'react';

const Admin_Variacion_Modal = ({ isOpen, onClose, onAdd, editData, isCopy }) => {
    const [talla, setTalla] = useState('unitalla');
    const [color, setColor] = useState({ name: 'sin especificar', code: '' });
    const [filteredColors, setFilteredColors] = useState([]);
    const [searchColor, setSearchColor] = useState('');
    const [precio, setPrecio] = useState(0);
    const [inventario, setInventario] = useState(0);
    const [ilimitado, setIlimitado] = useState(false);

    const colors = [
        { name: 'sin especificar', code: '' },
        { name: 'Aguamarina', code: '#7FFFD4' },
        { name: 'Amarillo', code: '#FFFF00' },
        { name: 'Amarillo Dorado', code: '#FFD700' },
        { name: 'Amarillo Mostaza', code: '#FFDB58' },
        { name: 'Azul', code: '#0000FF' },
        { name: 'Azul Acero', code: '#4682B4' },
        { name: 'Azul Celeste', code: '#ADD8E6' },
        { name: 'Azul Cielo', code: '#87CEEB' },
        { name: 'Azul Marino', code: '#000080' },
        { name: 'Beige', code: '#F5F5DC' },
        { name: 'Blanco', code: '#FFFFFF' },
        { name: 'Café', code: '#6F4E37' },
        { name: 'Café Claro', code: '#D2B48C' },
        { name: 'Café Oscuro', code: '#4B3621' },
        { name: 'Crema', code: '#FFFDD0' },
        { name: 'Cobre', code: '#B87333' },
        { name: 'Dorado', code: '#FFD700' },
        { name: 'Fucsia', code: '#FF00FF' },
        { name: 'Gris Claro', code: '#D3D3D3' },
        { name: 'Gris Oscuro', code: '#A9A9A9' },
        { name: 'Lavanda', code: '#E6E6FA' },
        { name: 'Lila', code: '#E6E6FA' },
        { name: 'Marrón', code: '#8B4513' },
        { name: 'Morado', code: '#800080' },
        { name: 'Naranja', code: '#FFA500' },
        { name: 'Naranja Quemado', code: '#FF4500' },
        { name: 'Negro', code: '#000000' },
        { name: 'Oliva', code: '#808000' },
        { name: 'Plateado', code: '#C0C0C0' },
        { name: 'Púrpura', code: '#9370DB' },
        { name: 'Rojo', code: '#FF0000' },
        { name: 'Rosa', code: '#FFC0CB' },
        { name: 'Rosa Chicle', code: '#FF69B4' },
        { name: 'Rosa Grisaceo', code: '#a08796' },
        { name: 'Transparente', code: 'transparent' },
        { name: 'Turquesa', code: '#40E0D0' },
        { name: 'Verde', code: '#00FF00' },
        { name: 'Verde Azulado Oscuro', code: '#325850' },
        { name: 'Verde Esmeralda', code: '#50C878' },
        { name: 'Verde Lima', code: '#32CD32' },
        { name: 'Verde Musgo Claro', code: '#749089' },
        { name: 'Verde Petroleo', code: '#214655' },
        { name: 'Violeta', code: '#8A2BE2' }
    ];

    useEffect(() => {
        if (editData) {
            setTalla(editData.talla);
            setColor({ name: editData.color, code: editData.code || '' });
            setPrecio(editData.precio);
            setInventario(editData.inventario);
            setIlimitado(editData.ilimitado);
        } else {
            setTalla('unitalla');
            setColor({ name: 'sin especificar', code: '' });
            setPrecio(0);
            setInventario(0);
            setIlimitado(false);
        }
        setFilteredColors(colors);
    }, [editData]);

    useEffect(() => {
        const normalize = (str) => str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
        const search = normalize(searchColor);
        const filtered = colors.filter(
            (c) => normalize(c.name).includes(search) || c.code.includes(search)
        );
    
        if (!filtered.some(c => c.name === 'sin especificar')) {
            const noColorOption = colors.find(c => c.name === 'sin especificar');
            if (noColorOption) {
                filtered.unshift(noColorOption);
            }
        }
    
        setFilteredColors(filtered);
    }, [searchColor]);
    

    if (!isOpen) return null;

    const handleAddClick = () => {
        const variacion = {
            talla,
            color: color.name,
            code: color.code,
            precio: parseFloat(precio),
            inventario: parseInt(inventario, 10),
            ilimitado
        };
        onAdd(variacion);
    };

    return (
        <div className="modal-container">
            <div className="modal">
                <h2>{editData && !isCopy ? "Editar variación" : "Agregar variación"}</h2>
                <div className="form-field">
                    <label>Talla</label>
                    <select value={talla} onChange={(e) => setTalla(e.target.value)}>
                        <option value="unitalla">Unitalla</option>
                        <option value="XS">XS</option>
                        <option value="S">S</option>
                        <option value="M">M</option>
                        <option value="L">L</option>
                        <option value="XL">XL</option>
                    </select>
                </div>
                <div className="form-field">
                    <label>
                        Color: <span style={{ color: color.code }}>{color.name}</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Buscar color"
                        value={searchColor}
                        onChange={(e) => setSearchColor(e.target.value)}
                    />
                    <select
                        value={color.name}
                        onChange={(e) => {
                            const selectedOption = e.target.options[e.target.selectedIndex];
                            setColor({
                                name: e.target.value,
                                code: selectedOption.getAttribute('code') || ''
                            });
                        }}
                    >
                        {filteredColors.map((c, index) => (
                            <option key={index} value={c.name} code={c.code}>
                                {c.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-field">
                    <label>Precio</label>
                    <input type="number" step="1" value={precio} onChange={(e) => setPrecio(e.target.value)} />
                </div>
                <div className="form-field">
                    <label>Inventario</label>
                    <input type="number" value={inventario} onChange={(e) => setInventario(e.target.value)} />
                    <div className="inline-field">
                        <input
                            type="checkbox"
                            checked={ilimitado}
                            onChange={(e) => setIlimitado(e.target.checked)}
                        />
                        <span>Ilimitado</span>
                    </div>
                </div>

                <div className="actions">
                    <button className="cancel" onClick={onClose}>
                        Cancelar
                    </button>
                    <button onClick={handleAddClick}>
                        {editData && !isCopy ? "Actualizar" : "Agregar"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Admin_Variacion_Modal;
